export default __webpack_public_path__ + "static/media/signature.2c8c72c0.jpg";